import type { Locale } from "@/entities/language";

export const APP_LOCALES: Locale[] = ["en", "fr"];

export const APP_DEFAULT_LOCALE: Locale = "en";
